/**
 * GiftCardsCardList — the phone/tablet card list container (BON-223).
 *
 * Phone stacks the cards one per row; tablet gets the same cards in a 2-col
 * grid — same tiering `BookingListBody` uses for its own card view.
 */
import { GiftCardsCard } from './GiftCardsCard';
import type { GiftCardListRow } from './giftCardTypes';

export function GiftCardsCardList({
  rows,
  isTablet,
}: {
  rows: GiftCardListRow[];
  isTablet: boolean;
}) {
  return (
    <div
      style={
        isTablet
          ? { display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 12, padding: 14 }
          : { display: 'flex', flexDirection: 'column', gap: 10, padding: 14 }
      }
    >
      {rows.map((row) => (
        <GiftCardsCard key={row.id} row={row} />
      ))}
    </div>
  );
}
